<template>
  <div class="allBox">
    <div v-wechat-title="($route.meta.title = articleTitle)"></div>
    <div class="topBox">
      <div class="title">{{ info.Title }}</div>
      <div class="info-top" style="padding: 10px 0px">
        <div @click.stop="toHomePage(info.MemberId)">
          <van-image
            fit="contain"
            :src="info.Photo"
            round
            error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
          />
          <span>{{ info.Headline }}</span>
        </div>
        <div
          class="follow"
          :class="info.IsFollow ? 'active' : ''"
          @click.stop="followChange(info.MemberId)"
        >
          <span class="iconfont icon-add" v-if="!info.IsFollow"></span
          >{{ info.IsFollow ? "已关注" : "关注" }}
        </div>
      </div>
      <div class="bigContent" v-html="content"></div>
    </div>

    <!-- 头像集 -->
    <div class="infoBox">
      <div class="dateBox">
        <div class="date">{{ info.CreateTime }}</div>
        <div>浏览数：{{ info.ClickNum }}</div>
      </div>
      <div
        class="watch-box"
        v-if="info.HeadPhotoList != null && info.HeadPhotoList.length > 0"
      >
        <div class="avater_wrap">
          <div v-for="(item, index) in info.HeadPhotoList" :key="index">
            <img
              v-if="index < 12"
              :src="item"
              :style="{
                left: `-${index * 15}px`,
                zIndex: `${20 - index}`,
              }"
            />
          </div>
        </div>
        <div
          v-if="info.LikeCount"
          class="num"
          :style="{
            left: `${
              info.HeadPhotoList.length > 12
                ? 12 * 15 + 20
                : info.HeadPhotoList.length * 15 + 20
            }px`,
          }"
        >
          <div
            class="iconfont icon-ellipsis"
            style="font-size: 25px"
            v-if="info.LikeCount > 12"
          ></div>
          <div style="display: flex; margin-left: 14px">
            <div class="overFlowOne">{{ info.LastLikeUser }}</div>
            <div>等{{ info.LikeCount }}人赞过</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 推荐文章 -->
    <div
      class="related-box"
      v-if="articleList != null && articleList.length > 0"
    >
      <div class="related-title">相关推荐</div>
      <div
        class="relatedItemBox"
        v-for="(item, index) in articleList"
        :key="index"
      >
        <div
          class="relatedItem"
          :class="
            item.CoverNum == 1
              ? 'setFlex'
              : '' || item.CoverNum == 0 || item.CoverNum == 3
              ? 'addpadding'
              : ''
          "
          @click.stop="toArticleDetail(item.ContentID)"
        >
          <div class="overFlowTwo" :class="item.CoverNum == 1 ? 'setW' : ''">
            {{ item.Title }}
          </div>
          <div class="imgs setTop" v-if="item.CoverNum == 3">
            <div v-for="(pitem, pindex) in item.ThumbnailList" :key="pindex">
              <van-image fit="cover" :src="pitem" />
            </div>
          </div>
          <div class="imgs setIW" v-if="item.CoverNum == 1">
            <van-image fit="cover" :src="item.Thumbnail" />
          </div>
          <div class="ri_btm" :class="item.CoverNum == 1 ? 'setW' : ''">
            <div class="ri_btm_left">
              <img :src="item.Photo" class="img" />
              <div class="overFlowOne">{{ item.Headline }}</div>
            </div>
            <div class="ri_btm_right">
              <span v-if="item.ClickNum">{{ item.ClickNum }}赞</span>
              <span v-if="item.CommentNum">{{ item.CommentNum }}评论</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 评论列表 -->
    <div class="container">
      <div class="commentTitle">
        <span>评论</span
        ><span v-if="info.CommentNum">({{ info.CommentNum }})</span>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getArticleComment"
      >
        <div
          class="commentBox"
          v-for="(item, index) in commentList"
          :key="index"
        >
          <div class="clistBox">
            <div class="commentList">
              <img class="avatar" :src="item.Photo" />
              <div class="content">
                <div class="bigBox">
                  <div class="commentName">{{ item.MemberName }}</div>
                  <div
                    class="rightBox"
                    @click.stop="onLikeChange(item.RecordId, index)"
                  >
                    <span
                      class="iconfont"
                      :class="
                        item.IsLike ? 'icon-favorites-fill' : 'icon-favorites'
                      "
                      :style="item.IsLike ? 'color:#D62F2F;' : ''"
                    ></span>
                    <span v-if="item.LikeCount">{{ item.LikeCount }}</span>
                  </div>
                </div>
                <div
                  class="comment"
                  @click.stop="clickComment(item.RecordId, index)"
                >
                  {{ item.Content }}
                </div>
              </div>
            </div>
            <div class="timeBox">
              <div class="time">{{ item.CreateTimeDesc }}</div>
              <div
                class="reply"
                v-if="item.CommentCount > 0"
                @click="showClick(item.RecordId, index)"
              >
                {{ item.CommentCount }} 回复
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div class="noComment" v-if="commentList.length == 0">
        <div class="kongIcon"><span class="iconfont icon-kong"></span></div>
        <div>暂无评论，留下你的看法吧~</div>
      </div>
    </div>

    <!--回复弹窗评论-->
    <van-popup
      v-model="replyModal"
      closeable
      :overlay="true"
      class="comment_container"
      position="bottom"
    >
      <van-list
        v-model="sloading"
        :finished="sfinished"
        :error.sync="serror"
        error-text="请求失败，点击重新加载"
        :immediate-check="false"
      >
        <div class="comment_top">{{ replyList.length }} 条评论</div>
        <div class="replyBox">
          <div class="listBox" v-for="(item, index) in replyList" :key="index">
            <div class="commentList">
              <img class="avatar" :src="item.Photo" />
              <div class="content">
                <div class="bigBox">
                  <div class="commentName">{{ item.MemberName }}</div>
                  <div
                    class="rightBox"
                    @click.stop="onReplyChange(item.RecordId, index)"
                  >
                    <span
                      class="iconfont"
                      :class="
                        item.IsLike ? 'icon-favorites-fill' : 'icon-favorites'
                      "
                      :style="item.IsLike ? 'color:#D62F2F;' : ''"
                    ></span>
                    <span v-if="item.LikeCount">{{ item.LikeCount }}</span>
                  </div>
                </div>
                <div class="comment">{{ item.Content }}</div>
              </div>
            </div>
            <div class="timeBox">
              <div class="time">{{ item.CreateTimeDesc }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-popup>

    <!--留言输入-->
    <van-overlay v-show="inputModal" @click="inputModal = false">
      <div class="selfComment-box" @click.stop="">
        <div class="scb_close" @click.stop="commentChange">
          <div class="iconfont icon-close"></div>
          <div class="scb_publish" @click.stop="commentConfirm">发表</div>
        </div>
        <textarea
          rows="3"
          :placeholder="placeholder"
          v-model="commentText"
          confirm-type="send"
          @keyup.enter="commentConfirm"
        ></textarea>
      </div>
    </van-overlay>

    <!-- 底部操作栏 -->
    <div class="btm_action_bar">
      <div class="inputSeize" @click.stop="showInput">说说你的看法吧~</div>
      <div class="operate">
        <!-- <div @click.stop="officialAccount">
          <span class="iconfont icon-weixin"></span>
        </div> -->
        <div @click.stop="shareHandle">
          <span class="iconfont icon-share1"></span>
        </div>
        <div @click.stop="collectChange(info.ContentId)">
          <span
            class="iconfont"
            :class="
              info.IsCollection ? 'icon-collection-fill' : 'icon-collection'
            "
            :style="info.IsCollection ? 'color:#D62F2F;' : ''"
          ></span>
        </div>
        <div @click.stop="likeChange(info.ContentId)">
          <span
            class="iconfont"
            :class="info.IsLike ? 'icon-favorites-fill' : 'icon-favorites'"
            :style="info.IsLike ? 'color:#D62F2F;' : ''"
          ></span>
        </div>
      </div>
    </div>

    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import { followMember, unFollowMember } from "@/api/index";
import { Icon, Overlay, List, Popup, Image, Toast } from "vant";
import {
  articleDetail,
  recommendArticle,
  articleComment,
  createArticleLike,
  cancelArticleLike,
  deleteCollections,
  addCollections,
  createArticleCommentLike,
  cancelArticleCommentLike,
  createArticleComment,
} from "@/api/article";

export default {
  name: "articleDetail",
  components: {
    "van-icon": Icon,
    "van-overlay": Overlay,
    "van-list": List,
    "van-popup": Popup,
    "van-image": Image,
    Toast,
  },
  data() {
    return {
      info: "",
      content: "", //文章富文本
      articleTitle: "", //文章title设置
      articleList: [],

      error: false,
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      commentList: [],

      serror: false,
      sloading: false,
      sfinished: false,
      stotal: 0,
      spageIndex: 1,
      replyList: [],

      showLayer: false,
      inputModal: false, //输入框
      replyModal: false, //回复评论弹窗

      placeholder: "点击发表评论", //占位符提示语
      commentText: "",

      crid: null, //父级id
      cIndex: 0,
    };
  },
  methods: {
    //跳转个人主页
    toHomePage(id) {
      this.$router.push({ path: "/homePage", query: { mid: id } });
    },

    //头条号操作
    followChange(id) {
      var newInfo = this.info;
      if (newInfo.IsFollow) {
        unFollowMember({ MemberId: id }).then((res) => {
          Toast("取消关注");
          newInfo.IsFollow = false;
        });
      } else {
        followMember({ MemberId: id }).then((res) => {
          Toast("关注成功");
          newInfo.IsFollow = true;
        });
      }
      this.info = newInfo;
    },

    //跳转公众号
    officialAccount() {
      window.location.href =
        "https://mp.weixin.qq.com/s/n7PtZNJDhiWnxQq04I8sSg";
    },

    //跳转文章详情
    toArticleDetail(id) {
      window.location.href = "/articleDetail?id=" + id;
    },

    //获取文章详情
    getArticleDetail() {
      var that = this;
      var data = {
        ContentId: that.$route.query.id,
      };
      articleDetail(data).then((response) => {
        that.info = response.Data;
        that.content = response.Data.Content;
        that.content = that.content.replace(
          /&lt;p/g,
          "<p style='text-indent:0px !important;'"
        );
        that.content = that.content.replace(
          /img/g,
          "img style='width:100% !important;height:auto !important;text-indent:0px !important;'"
        );
        that.content = that.content.replace(
          /video/g,
          "video style='width:100% !important;height:auto !important;'"
        );
        that.content = that.content.replace(
          /<table/g,
          "<table style='width:100% !important;height:auto !important;'"
        );

        that.content = that.content.replace(
          /<ul/g,
          "<ul style='width:100% !important;'"
        );
        //解析富文本
        that.content = that.Common.escape2Html(that.content);
        //缓存title
        that.articleTitle = response.Data.Title;
        sessionStorage.setItem("articleTitle", response.Data.Title);
        that.getRecommendArticle(response.Data.MemberId);
        //调用转发
        getShareData(
          window.location.href,
          response.Data.Title,
          that.Common.ToText(response.Data.Content).substr(0, 50),
          response.Data.Thumbnail
            ? response.Data.Thumbnail
            : "https://mapi.alighting.com/upload/cover/ShareLogo.jpg"
        );
      });
    },

    //获取推荐文章列表
    getRecommendArticle(mid) {
      var data = {
        ContentId: this.$route.query.id,
        MemberId: mid,
      };
      recommendArticle(data).then((response) => {
        this.articleList = response.Data.List;
      });
    },

    //获取文章评论
    getArticleComment() {
      var that = this;
      var data = {
        ArticleId: that.$route.query.id,
        CommentRecordId: 0,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      articleComment(data).then((response) => {
        if (that.pageIndex == 1) {
          that.commentList = [...response.Data.List];
        } else {
          that.commentList = [...that.commentList, ...response.Data.List];
        }
        that.total = response.Data.Total;
        that.pageIndex += 1;
        // 加载状态结束
        that.loading = false;
        // 数据全部加载完成
        if (that.commentList.length >= that.total) {
          that.finished = true;
        }
      });
    },

    //分享
    shareHandle() {
      this.showLayer = true;
    },

    //关闭评论弹窗
    commentChange() {
      this.inputModal = false;
    },

    //点击评论
    showInput() {
      this.commentText = "";
      this.placeholder = "点击发表评论";
      this.crid = 0;
      this.inputModal = !this.inputModal;
    },

    //点击回复显示弹窗
    showClick(id, index) {
      this.crid = id;
      this.cIndex = index;
      this.replyModal = true;
      this.spageIndex = 1;
      this.replyList = [];
      this.getArticleReply();
    },

    //点击评论内容进行回复
    clickComment(id, index) {
      this.crid = id;
      this.cIndex = index;
      this.commentText = "";
      this.inputModal = !this.inputModal;
      this.placeholder = "@" + this.commentList[index].MemberName;
    },

    //获取文章评论回复
    getArticleReply() {
      var that = this;
      var data = {
        MemberId: that.$route.query.mid,
        ArticleId: that.$route.query.id,
        CommentRecordId: that.crid,
        Page: {
          PageSize: 10,
          PageIndex: that.spageIndex,
        },
      };
      articleComment(data).then((response) => {
        if (that.spageIndex == 1) {
          that.replyList = [...response.Data.List];
        } else {
          that.replyList = [...that.replyList, ...response.Data.List];
        }
        that.stotal = response.Data.Total;
        that.spageIndex += 1;
        // 加载状态结束
        that.sloading = false;
        // 数据全部加载完成
        if (that.replyList.length >= that.stotal) {
          that.sfinished = true;
        }
      });
    },

    //点击发送
    commentConfirm() {
      var that = this;
      var data = {
        Content: that.commentText,
        ArtilceId: that.$route.query.id,
        CommentRecordId: that.crid ? that.crid : 0,
      };
      createArticleComment(data).then((res) => {
        setTimeout(() => {
          Toast("发表成功");
          that.commentText = "";
          this.info.CommentNum = this.info.CommentNum + 1;
          setTimeout(() => {
            that.commentChange();
            if (that.crid) {
              that.spageIndex = 1;
              that.replyList = [];
              that.commentList[that.cIndex].CommentCount =
                that.commentList[that.cIndex].CommentCount + 1;
              that.getArticleReply();
            } else {
              that.pageIndex = 1;
              that.commentList = [];
              that.getArticleComment();
            }
          }, 1000);
        }, 0);
      });
    },

    //评论点赞
    onLikeChange(rid, index) {
      var list = this.commentList;
      if (list[index].IsLike) {
        var data = {
          RecordId: rid,
          ArticleId: this.$route.query.id,
        };
        cancelArticleCommentLike(data).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        var data = {
          RecordId: rid,
          ArticleId: this.$route.query.id,
        };
        createArticleCommentLike(data).then((res) => {
          list[index].IsLike = true;
          list[index].LikeCount++;
        });
      }
      this.commentList = list;
    },

    //回复评论点赞
    onReplyChange(rid, index) {
      var list = this.replyList;
      if (list[index].IsLike) {
        var data = {
          RecordId: rid,
          ArticleId: this.$route.query.id,
        };
        cancelArticleCommentLike(data).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        var data = {
          RecordId: rid,
          ArticleId: this.$route.query.id,
        };
        createArticleCommentLike(data).then((res) => {
          list[index].IsLike = true;
          list[index].LikeCount++;
        });
      }
      this.replyList = list;
    },

    //点赞操作
    likeChange(id) {
      var newInfo = this.info;
      if (newInfo.IsLike) {
        cancelArticleLike({ ContentId: id }).then((res) => {
          newInfo.IsLike = false;
          this.getArticleDetail();
        });
      } else {
        createArticleLike({ ContentId: id }).then((res) => {
          newInfo.IsLike = true;
          this.getArticleDetail();
        });
      }
      this.info = newInfo;
    },

    // 收藏操作
    collectChange(id) {
      var newInfo = this.info;
      if (newInfo.IsCollection) {
        deleteCollections({ ObjectId: id, CType: 1 }).then((res) => {
          newInfo.IsCollection = false;
        });
      } else {
        addCollections({ ObjectId: id, CType: 1 }).then((res) => {
          newInfo.IsCollection = true;
        });
      }
      this.info = newInfo;
    },
  },

  created() {},
  mounted() {
    this.getArticleDetail();
  },
};
</script>
<style scoped src="../../../static/css/common.css"></style>
<style scoped src="../../../static/css/articleDetail.css"></style>
